export default [
{
    name: 'Dashboard',
    icon: 'nc-icon nc-tv-2',
    path: '/cs_dashboard'
  },
  {
    name: 'Companies',
    icon: 'nc-icon nc-shop',
    path: '/companies'
  },
  {
    name: 'Task Log',
    icon: 'nc-icon nc-briefcase-24',
    path: '/task-log'
  },
  {
    name: 'People',
    icon: 'nc-icon nc-circle-10',
    path: '/people'
  },
   {
    name: 'Compliance',
    icon: 'nc-icon nc-bank',
    path: '/compliance'
  },
    {
    name: 'Messages',
    icon: 'nc-icon nc-email-85',
    path: '/request-messages'
  },
  {
    name: 'Billing',
    icon: 'nc-icon nc-money-coins',
    path: '/invoices'
  },
  
   {
    name: 'E-Sign Overview',
    icon: 'nc-icon nc-send',
    path: '/esigning-overview'
  },
   {
    name: 'Associates',
    icon: 'nc-icon nc-circle-10',
    path: '/associates'
  },
  
  {
    name: 'Notification Log',
    icon: 'nc-icon nc-bell-55',
    path: '/notification-log'
  },
  {
    name: 'Logout',
    icon: 'nc-icon nc-button-power',
    path: '/logout'
  },
 /* {
    name: 'Dashboard',
    icon: 'nc-icon nc-bank',
    path: '/admin/overview'
  },
  {
    name: 'Pages',
    icon: 'nc-icon nc-book-bookmark',
    children: [
      {
        name: 'Timeline',
        path: '/pages/timeline'
      },
      {
        name: 'User Profile',
        path: '/pages/user'
      },
      {
        name: 'Login',
        path: '/login'
      },
      {
        name: 'Register',
        path: '/register'
      },
      {
        name: 'Lock',
        path: '/lock'
      }
    ]
  },
  {
    name: 'Components',
    icon: 'nc-icon nc-layout-11',
    children: [{
      name: 'Buttons',
      path: '/components/buttons'
    },
    {
      name: 'Grid System',
      path: '/components/grid-system'
    },
    {
      name: 'Panels',
      path: '/components/panels'
    },
    {
      name: 'Sweet Alert',
      path: '/components/sweet-alert'
    },
    {
      name: 'Notifications',
      path: '/components/notifications'
    },
    {
      name: 'Icons',
      path: '/components/icons'
    },
    {
      name: 'Typography',
      path: '/components/typography'
    }]
  },
  {
    name: 'Forms',
    icon: 'nc-icon nc-ruler-pencil',
    children: [{
      name: 'Regular Forms',
      path: '/forms/regular'
    },
    {
      name: 'Extended Forms',
      path: '/forms/extended'
    },
    {
      name: 'Validation Forms',
      path: '/forms/validation'
    },
    {
      name: 'Wizard',
      path: '/forms/wizard'
    }
    ]
  },
  {
    name: 'Table List',
    icon: 'nc-icon nc-single-copy-04',
    collapsed: true,
    children: [{
      name: 'Regular Tables',
      path: '/table-list/regular'
    },
    {
      name: 'Extended Tables',
      path: '/table-list/extended'
    },
    {
      name: 'Paginated Tables',
      path: '/table-list/paginated'
    }
    ]
  },
  {
    name: 'Maps',
    icon: 'nc-icon nc-pin-3',
    children: [{
      name: 'Google Maps',
      path: '/maps/google'
    },
    {
      name: 'Full Screen Maps',
      path: '/maps/full-screen'
    },
    {
      name: 'Vector Maps',
      path: '/maps/vector-map'
    }
    ]
  },
  {
    name: 'Widgets',
    icon: 'nc-icon nc-box',
    path: '/admin/widgets'
  },
  {
    name: 'Charts',
    icon: 'nc-icon nc-chart-bar-32',
    path: '/charts'
  },
  {
    name: 'Calendar',
    icon: 'nc-icon nc-calendar-60',
    path: '/calendar'
  },
  */
]
